<div class="row main-title-class" *ngIf="impactItems?.ingredientDataSourceList?.length > 0">
  <div class="row table-div">
    <div class="indicatorName">Product name: {{ impactItems?.productName }}</div>
  </div>
</div>

<div class="row table-div" *ngIf="impactItems?.ingredientDataSourceList?.length > 0">
  <div class="tableHeadingForLifecycleStage">
    <div>Ingredient</div>
  </div>
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td *ngIf="!impactItems?.showIngredientDataSourceList?.isIngredientNameAllZero">
            {{ reportResource.lblIngredients }}
          </td>
          <td *ngIf="!impactItems?.showIngredientDataSourceList?.isSourceAllZero">
            {{ reportResource.lblSource }}
          </td>
          <td *ngIf="!impactItems?.showIngredientDataSourceList?.isTimePeriodAllZero">
            {{ reportResource.lblTimePeriod }}
          </td>
          <td *ngIf="!impactItems?.showIngredientDataSourceList?.isGeoGraphyAllZero">
            {{ reportResource.lblGeoGraphy }}
          </td>
          <td *ngIf="!impactItems?.showIngredientDataSourceList?.isProcessAllZero">
            {{ reportResource.lblProcess }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ingredient of impactItems?.ingredientDataSourceList">
          <td *ngIf="!impactItems?.showIngredientDataSourceList?.isIngredientNameAllZero">
            {{ ingredient.ingredientName }}
          </td>
          <td *ngIf="!impactItems?.showIngredientDataSourceList?.isSourceAllZero">
            {{ ingredient.source }}
          </td>
          <td *ngIf="!impactItems?.showIngredientDataSourceList?.isTimePeriodAllZero">
            {{ ingredient.timePeriod }}
          </td>
          <td *ngIf="!impactItems?.showIngredientDataSourceList?.isGeoGraphyAllZero">
            {{ ingredient.geoGraphy }}
          </td>
          <td *ngIf="!impactItems?.showIngredientDataSourceList?.isProcessAllZero">
            {{ ingredient.process }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
